import React, { useState } from 'react';
import { DSModal, DSButton, DSInput } from '../design-system/primitives';

// Shared confirm dialog, replacing window.confirm(). Now built on DSModal rather than
// App.css's .modal-overlay/.modal, so it inherits the design system's dialog semantics
// (labelled aria-modal dialog, backdrop dismiss) instead of reimplementing a subset.
//
// hideClose is set because the dialog already ends with an explicit Cancel action, and
// two dismiss controls side by side is just noise.
//
// `confirmPhrase` escalates a plain confirm into a typed one: the user has to retype the
// given phrase before the confirm button unlocks. For actions whose blast radius reaches
// past the thing named in the title - deleting a PinGolf season also reverses handicaps,
// payouts and badges on other members' accounts - a single tap is too cheap, and making
// someone type the name is what forces them to read which one they picked.
function ConfirmModal({
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmPhrase,
  danger = false,
  submitting = false,
  onConfirm,
  onCancel
}) {
  const [typed, setTyped] = useState('');
  const phraseMatched = !confirmPhrase || typed.trim() === confirmPhrase;

  return (
    <DSModal title={title} size="sm" onClose={onCancel} hideClose>
      {message && <p className="ds-modal-message">{message}</p>}
      {confirmPhrase && (
        <DSInput
          id="confirm-modal-phrase"
          label={`Type ${confirmPhrase} to confirm`}
          value={typed}
          onChange={(event) => setTyped(event.target.value)}
          disabled={submitting}
          autoComplete="off"
          autoFocus
        />
      )}
      <div className="ds-modal-actions">
        <DSButton appearance="outline" tone="neutral" onClick={onCancel} disabled={submitting}>
          {cancelLabel}
        </DSButton>
        <DSButton
          appearance="solid"
          tone={danger ? 'danger' : 'primary'}
          onClick={onConfirm}
          disabled={submitting || !phraseMatched}
        >
          {submitting ? 'Working...' : confirmLabel}
        </DSButton>
      </div>
    </DSModal>
  );
}

export default ConfirmModal;
